module.exports = __webpack_public_path__ + "img/Trip-creator-ss2.56bb60e0.png";